import { render, staticRenderFns } from "./RequiresAnnounce.vue?vue&type=template&id=4e689706&"
import script from "./RequiresAnnounce.vue?vue&type=script&lang=ts&"
export * from "./RequiresAnnounce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports